import { Observable } from "rxjs/internal/Observable";
import { UseCase } from "../../base/use-case";
import { TeleconsultaInterestStateModel } from "../../models/comercial/teleconsulta-interest-state.model";
import { ComercialRepository } from "../../repositories/comercial.repository";

export class GetTeleconsultaInterestUseCase implements UseCase<{id:string}, TeleconsultaInterestStateModel> {
    constructor(private comercialRepository: ComercialRepository) { }
    execute(
        params: {id: string},
    ): Observable<TeleconsultaInterestStateModel> {
        return this.comercialRepository.getTeleconsultaInterest(params);
    }
}
